import React from 'react';
import SectionTitle from '../SectionTitle'
import sImg1 from '../../images/story/1.jpg'
import sImg2 from '../../images/story/2.jpg'
import sImg3 from '../../images/story/3.jpg'
import sImg4 from '../../images/story/4.jpg'

import shape1 from '../../images/rsvp/shape1.png'
import shape2 from '../../images/rsvp/shape2.png'

const StorySection = (props) => {


    return (
        <section className="story-section section-padding" id="story">
            <div className="container">
                <div className="row">
                    <SectionTitle MainTitle={'Nuestra historia'} />
                </div>
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="story-timeline">
                            <div className="row">
                                <div className="col offset-lg-6 col-lg-6 col-12 text-holder">
                                    <span className="heart">
                                        <i className="fi flaticon-balloon"></i>
                                    </span>
                                </div>
                            </div>
                            <div className="story-timeline-item s1">
                                <div className="row align-items-center">
                                    <div className="col col-lg-6 col-12">
                                        <div className="img-holder right-align-text fadeInLeftSlow" data-wow-duration="1500ms">
                                            <img src={sImg1} className="img img-responsive" alt="stroy" />
                                        </div>
                                    </div>
                                    <div className="col col-lg-6 col-12">
                                        <div className="story-text left-align-text fadeInRightSlow" data-wow-duration="2000ms">
                                            <h3>El Match y el Puente del Diablo</h3>
                                            {/* <span className="date">19 Ago 2019</span> */}
                                            <div className="line-shape">
                                                <div className="outer-ball">
                                                    <div className="inner-ball"></div>
                                                </div>
                                            </div>
                                            <p>En 2019, María llegó a Tarragona como veterinaria 🐾 y se descargó Tinder para hacer amigos. En la primera cita, Cristian pidió un plato que a María no le gustaba, pero lo compensó con su pulsera feminista 💜. En enero de 2020, María formalizó la relación en un sitio emblemático de Tarragona, el Puente del Diablo.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="story-timeline-item">
                                <div className="row align-items-center">
                                    <div className="col col-lg-6 col-12 order-lg-1 order-2 text-holder left-text">
                                        <div className="story-text right-align-text fadeInLeftSlow" data-wow-duration="2000ms">
                                            <h3>De 0 a 100 con pandemia y gato incluido</h3>
                                            {/* <span className="date">22 May 2021</span> */}
                                            <div className="line-shape s2">
                                                <div className="outer-ball">
                                                    <div className="inner-ball"></div>
                                                </div>
                                            </div>
                                            <p>Una semana antes del confinamiento, decidieron irse a vivir juntos 🏠 (sin saber la que se les venía encima...). Y en medio del caos apareció Oreo, el "hijo-gato" rescatado con apenas unas horas de vida, quien superó todas las expectativas y consiguió salir adelante 💪🏽 #Supergato</p>
                                        </div>
                                    </div>
                                    <div className="col col-lg-6 col-12 order-lg-2 order-1">
                                        <div className="img-holder left-align-text">
                                            <img src={sImg2} alt="stroy" className="img img-responsive fadeInRightSlow" data-wow-duration="1500ms" />
                                            <span className="heart">
                                                <i className="fi flaticon-dance"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="story-timeline-item">
                                <div className="row align-items-center">
                                    <div className="col col-lg-6 col-12">
                                        <div className="img-holder right-align-text left-site right-heart">
                                            <img src={sImg3} alt="stroy" className="img img-responsive fadeInLeftSlow" data-wow-duration="1500ms" />
                                            <span className="heart">
                                                <i className="fi flaticon-dove"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col col-lg-6 col-12">
                                        <div className="story-text left-align-text fadeInRightSlow" data-wow-duration="2000ms">
                                            <h3>Cádiz, Picolina y el viaje a Tailandia</h3>
                                            {/* <span className="date">14 Feb 2024</span> */}
                                            <div className="line-shape">
                                                <div className="outer-ball">
                                                    <div className="inner-ball"></div>
                                                </div>
                                            </div>
                                            <p>En Cádiz estuvieron muy felices durante 3 años y medio 🏖. Allí decidieron adoptar a Picolina, la hermanita de Oreo. Pero finalmente se mudaron a Tarragona porque la familia tiró de ellos como un imán 🧲; no sin antes pegarse un viajecito de un mes a Tailandia 🛕</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="story-timeline-item">
                                <div className="row align-items-center">
                                    <div className="col col-lg-6 col-12 order-lg-1 order-2 text-holder left-text">
                                        <div className="story-text right-align-text fadeInLeftSlow" data-wow-duration="2000ms">
                                        <h3>El Sí en el Puente y la Nueva Vida</h3>
                                        <span className="date">14 Feb 2024</span>
                                            <div className="line-shape s2">
                                                <div className="outer-ball">
                                                    <div className="inner-ball"></div>
                                                </div>
                                            </div>
                                            <p>El 14 de febrero de 2024, Cristian se puso de rodillas y le pidió matrimonio a María en el mismísimo Puente del Diablo 💍, ella dijo que sí (por eso estás leyendo esto). Ahora viven en un pisito cerca de Tarragona 🏡 que acaban de terminar de reformar.</p>
                                        </div>
                                    </div>
                                    <div className="col col-lg-6 col-12 order-lg-2 order-1">
                                        <div className="img-holder left-align-text">
                                            <img src={sImg4} alt="stroy" className="img img-responsive fadeInRightSlow" data-wow-duration="1500ms" />
                                            <span className="heart">
                                                <i className="fi flaticon-dance"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="shape-1">
                <div className="sticky-shape">
                    <img src={shape1} alt="" style={{filter: 'grayscale(1)'}} />
                </div>
            </div>
            <div className="shape-2">
                <div className="sticky-shape">
                    <img src={shape2} alt="" style={{filter: 'grayscale(1)'}} />
                </div>
            </div>
        </section>
    )
}


export default StorySection;